// @flow

import { useEffect } from 'react';

import { Controller, useFormContext } from 'react-hook-form';

import { View } from 'reshaped';

import { Button } from '@gandi/reshaped';
import { useTranslator } from '@gandi/translate';

type Props = { showIndividualType?: boolean };

export function OrgaTypePills({
  showIndividualType = false,
}: Props): React.MixedElement {
  const { __ } = useTranslator();

  const { control, watch, setValue } = useFormContext();
  const currentType = watch('type');

  // set a default type
  // outside of default values
  // to make it dirty
  useEffect(() => {
    if (currentType === undefined) {
      setValue('type', 'company');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const allOrgaTypes = showIndividualType
    ? [{ label: __('Individual'), value: 'individual' }]
    : [];

  allOrgaTypes.push(
    { label: __('Company'), value: 'company' },
    { label: __('Public Body'), value: 'publicbody' },
    { label: __('Association'), value: 'association' },
  );

  return (
    <Controller
      name="type"
      control={control}
      render={({ field }) => (
        <View gap={3} direction="row" paddingBlock={1}>
          {allOrgaTypes.map(orgaType => {
            const isSelected = field.value === orgaType.value;

            return (
              <Button
                rounded
                key={orgaType.value}
                color={isSelected ? 'primary' : undefined}
                variant={isSelected ? 'solid' : 'outline'}
                onClick={() => field.onChange(orgaType.value)}
              >
                {orgaType.label}
              </Button>
            );
          })}
        </View>
      )}
    />
  );
}
